export function setItems(key:any,data:any){
    localStorage.setItem(key,JSON.stringify(data));
}
export function getItems(key:any){
    let data = localStorage.getItem(key);
    return data?JSON.parse(data):''
}